module.exports = __webpack_public_path__ + "890bd988-5306-43ff-bd4b-922bc5ebdeb4.ttf";